module.exports = __webpack_public_path__ + "static/media/upcomming_pragati_flagIcon.e57ddbdd.svg";